<script lang="ts">
  import Map from "./map/Map.svelte";
  export let ready;
  export let coords: Float64Array;
</script>

<main>
  {#if ready}
    <Map {coords}/>
  {/if}
</main>

<svelte:head>
  <script
    defer
    async
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCe7aGhDhKUDDzcvWeR9xuk0xVUv7n8ufU&callback=initMap">
  </script>
</svelte:head>